import { useQuery } from "@tanstack/react-query";
import { getPostTags } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook to fetch blog post tags with post counts
 */
export function useGetPostTags() {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["postTags", i18next.language],
        queryFn: () => getPostTags(),
        retry: false,
        staleTime: 1000 * 60 * 15, // 15 minutes (tags don't change often)
        cacheTime: 1000 * 60 * 30, // 30 minutes
    });

    const tags = data?.data?.data || [];

    return { isLoading, error, tags, refetch };
}
